module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/icon_arrow_01-f5b5625fa5a308b79ee3624651a47b8c.png";